import { getPage } from "./getPage";

export const getProduct = (products, containerType, data) => {
  const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  let productHTML = '';
  let numProducts;

  if (containerType === 'ha-product__content') {
    numProducts = 4;
    const randomProducts = [];
  
    const filteredProducts = window.limitSliderToSix
      ? products.filter(product => !product.nutrition_facts || product.nutrition_facts.length === 0)
      : products;
  
    while (randomProducts.length < numProducts) {
      const randomIndex = getRandomInt(0, filteredProducts.length - 1);
      const randomProduct = filteredProducts[randomIndex];
      if (!randomProducts.some(product => product.sku === randomProduct.sku)) {
        randomProducts.push(randomProduct);
      }
    }
  
    productHTML = randomProducts.map(product => `
      <div class="home-product__box get_product" data-order-type="${product.sku}">
        <div class="home-product__img">
          ${product.templates.retail > 0 ? `<div class="lbl-sale">Sale</div>` : ''}
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
          <div class="home-product__btn">Product Details</div>
        </div>
        
        <div class="home-product__title">${product.templates.title}</div>
        
        <div class="home-product__info">
          <div class="home-product__price">
            ${product.templates.retail > 0 ? `<span>${window.options?.currency ? window.options.currency : '$'}${product.templates.retail}</span>` : ''}
            ${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}
          </div>
        </div>
      </div>
    `).join('');
  } else if (containerType === 'home-product__content') {
    const contentContainer = $(`.${containerType}`);
    const tabList = $('.tab-list');
    const tabItems = $('.tab-item');

    function renderProducts(productsToRender) {
      productHTML = productsToRender
        .map(product => `
          <div class="home-product__box get_product" data-order-type="${product.sku}">
            <div class="home-product__img">
              ${product.templates.retail > 0 ? `<div class="lbl-sale">Sale</div>` : ''}
              <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
              <div class="home-product__btn">Product Details</div>
            </div>
            
            <div class="home-product__title">${product.templates.title}</div>
            
            <div class="home-product__info">
              <div class="home-product__price">
                ${product.templates.retail > 0 ? `<span>${window.options?.currency ? window.options.currency : '$'}${product.templates.retail}</span>` : ''}
                ${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}
              </div>
            </div>
          </div>
        `).join('');

      contentContainer.html(productHTML);

      $('.get_product').off('click').on('click', function (e) {
        const $target = $(e.currentTarget);
        const sku = $target.data('order-type');
        localStorage.setItem('product', sku);

        window.location.href = `${getPage('product')}&id=${sku}`;
      });

      
    }

    function handleTabClick(event) {
      const tab = $(event.target).data('tab');

      tabItems.removeClass('active');
      $(event.target).addClass('active');

      if (tab === 'all') {
        renderProducts(products.slice(0, 9));
      } else if (tab === 'most-viewed') {
        renderProducts(products.slice(0, 4));
      } else if (tab === 'trend-now') {
        renderProducts(products.slice(4, 10));
      }
    }

    tabList.on('click', '.tab-item', handleTabClick);

    renderProducts(products.slice(0, 9));
  } else if (containerType === 'product-list') {
    numProducts = products.length;
    productHTML = products.map(product => `
       ${product.templates.title} <br>
       ${product.templates.title.toUpperCase()} BOTTLE - ${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}<br> <br>
    `).join('');
  } else if (containerType === 'ap-content') {
    numProducts = products.length;
    productHTML = products.map(product => `
      <div class="ap-item get_product" data-order-type="${product.sku}">
        <div  class="ap-item__img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="ap-item__name">${product.templates.title}</div>
        <div class="ap-item__price">${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}</div>
      </div>
    `).join('');
  } else if (containerType === 'banner-flex') {
    let filteredProducts = products;
  
    if (window.limitSliderToSix) {
      filteredProducts = products.filter(product => !product.nutrition_facts || product.nutrition_facts.length === 0);
    }
  
    const numProducts = 3;
    const randomProducts = [];
    
    while (randomProducts.length < numProducts && filteredProducts.length > 0) {
      const randomIndex = getRandomInt(0, filteredProducts.length - 1);
      const randomProduct = filteredProducts[randomIndex];
  
      if (!randomProducts.some(product => product.sku === randomProduct.sku)) {
        randomProducts.push(randomProduct);
      }
    }
  
    productHTML = randomProducts.map(product => `
      <div class="banner-box get_product" data-order-type="${product.sku}">
        <div class="banner-box__img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="banner-box__info">
          <div class="banner-box__name">
            ${product.templates.title}
          </div>
          <div class="banner-box__sku">
            SKU: ${product.sku}
          </div>
          <div class="banner-box__arr">
            <img src="/static/common/images/arr-v7.svg" class="arr-v7">
          </div>
          
        </div>
        
       
      </div>
    `).join('');
  } else if (containerType === 'home-flex') {
    numProducts = products.length;
    productHTML = products.map(product => `
      <div class="home-flex-itm">
        <div class="home-flex-itm-left">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="home-flex-itm-right">
          <h2 class='headerTitle'></h2>
          <a data-page="shop" class="get_page home-button button">Check the store</a>
        </div>
      </div>
    `).join('');
  } else if (containerType === 'marquee-track') {
    productHTML = products.map(product => `
      <div class="itm">
        <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
      </div>
    `).join('');
    productHTML = productHTML + productHTML; 
  } else if (containerType === 'home-product__content-shop') {
    const contentContainer = $('.home-product__content-shop');
    const sortSelect = $('#sort-select');
    let currentProducts = [...products];

    function renderProducts(productsToRender) {
      productHTML = productsToRender.map(product => `
        <div class="home-product__box get_product" data-order-type="${product.sku}">
          <div class="home-product__img">
            ${product.templates.retail > 0 ? `<div class="lbl-sale">Sale</div>` : ''}
            <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
            <div class="home-product__btn">Product Details</div>
          </div>
          <div class="home-product__title">${product.templates.title}</div>
          <div class="home-product__info">
            <div class="home-product__price">
              ${product.templates.retail > 0
                ? `<span>${window.options?.currency || '$'}${product.templates.retail}</span>`
                : ''}
              ${window.options?.currency || '$'}${product.price.toFixed(2)}
            </div>
          </div>
        </div>
      `).join('');


      setTimeout(() => {
        $('.get_product').off('click').on('click', function (e) {
          const sku = $(this).data('order-type');
          localStorage.setItem('product', sku);
          window.location.href = `${getPage('product')}&id=${sku}`;
        });
      }, 0);
    }

    function sortProducts() {
      const value = sortSelect.val();

      if (value === 'az') {
        currentProducts.sort((a, b) => a.templates.title.localeCompare(b.templates.title));
      } else if (value === 'price-asc') {
        currentProducts.sort((a, b) => a.price - b.price);
      } else if (value === 'price-desc') {
        currentProducts.sort((a, b) => b.price - a.price);
      }
    }


    sortSelect.on('change', function () {
      sortProducts();
      renderProducts(currentProducts);
      $(`.${containerType}`).html(productHTML);
    });
    sortSelect.val('az'); 
    sortProducts();
    renderProducts(currentProducts);
  } else if (containerType === 'cart-product-list') {
    productHTML = products.map(product => `
      <div class="home-product__box get_product" data-order-type="${product.sku}">
        <div class="home-product__img">
          ${product.templates.retail > 0 ? `<div class="lbl-sale">Sale</div>` : ''}
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
          <button class="home-product__btn">Add to cart</button>
        </div>
        
        <div class="home-product__title">${product.templates.title}</div>
        
        <div class="home-product__info">
          <div class="home-product__price">
            ${product.templates.retail > 0 ? `<span>${window.options?.currency ? window.options.currency : '$'}${product.templates.retail}</span>` : ''}
            ${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}
          </div>
        </div>
      </div>
    `).join('');
  }



  $(`.${containerType}`).html(productHTML);


  $('.get_product').click(function (e) {
    const $target = $(e.currentTarget);
    const sku = $target.data('order-type');
    localStorage.setItem('product', sku);

    window.location.href = `${getPage ('product')}&id=${sku}`
  });

  $(document).on('click', '.get_page', function () {
    const page = $(this).data('page');
    window.location.href = getPage(page);
  });

  if (data && data.templates && data.templates.headerTitle) {
    $('.headerTitle').html(data.templates.headerTitle);
  }
};
